<template>
  <div class="manage-content">
    <div class="location">达人管理中心 / 达人信息</div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <info-basic :name="name"
                  :nickname="nickname"
                  :phone="phone"
                  :sex="sex"
                  :content="content"
                  :birthday="birthday"
                  :occupation_name="occupation_name">
      </info-basic>
    </div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <info-friend :wechat_group="wechat_group"
                   :wechat_friend_num="wechat_friend_num"
                   :wechat_group_num="wechat_group_num"></info-friend>
    </div>
  </div>
</template>
<script>
import {myDarenInfo} from '@/config/api.js'
import InfoBasic from './components/InfoBasic'
import InfoFriend from './components/InfoFriend'
export default {
  name: 'DarenInfo',
  components: { InfoBasic, InfoFriend },
  data () {
    return {
      name: '',
      nickname: '',
      phone: null,
      sex: '',
      content: '',
      birthday: null,
      occupation_name: '',
      wechat_group: '',
      wechat_friend_num: '',
      wechat_group_num: {}
    }
  },
  methods: {
    getInfo () {
      let data = {
        user_id: this.$store.state.user_id,
        user_type: this.$store.state.user_type,
      };
      this.$post(myDarenInfo, data)
              .then(res => {
                const data = res.data;
                this.name = data.name;
                this.nickname = data.nickname;
                this.phone = data.phone;
                this.sex = data.sex;
                this.birthday = data.birthday;
                this.occupation_name = data.occupation_name;
                this.content = data.content;
                this.wechat_group = data.wechat_group;
                this.wechat_friend_num = data.wechat_friend_num;
                this.wechat_group_num = JSON.parse(data.wechat_group_num);
              })
              .catch(err => {
                window.console.log(err)
              })
    }
  },
  created() {
    this.getInfo()
  }
}
</script>
